import { render, staticRenderFns } from "./FireOutbreakReaction.factory.vue?vue&type=template&id=19816a6f"
import script from "./FireOutbreakReaction.factory.vue?vue&type=script&setup=true&lang=ts"
export * from "./FireOutbreakReaction.factory.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports